import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Armada',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Armada',
        href: '/adm/armada',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_armada',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'code_armada',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nopol',
        label: 'Nomer Polisi',
      },
      {
        key: 'driver',
        label: 'Driver',
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'remark',
        label: 'Keterangan',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    pabrik: [],
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeArmada(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchArmada(context, params = null) {
    let result = await ApiGetRequest(`armada`, params);
    return !result.error ? result.data.object : [];
  },

  async getPabrik({ commit }, payload = null) {
    commit('changeArmada', {
      loading: true,
    });

    let result = await ApiGetRequest(`pabrik`, payload);
    commit('changeArmada', {
      pabrik: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListArmada({ commit, state }) {
    commit('changeArmada', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`armada`, params);
    commit('changeArmada', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailArmada({ commit }, payload = null) {
    commit('changeArmada', {
      loading: true,
    });

    let result = await ApiGetRequest(`armada/${payload.id}`);
    commit('changeArmada', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeArmada', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`armada/import`, {
      items: data.import_form || [],
    });

    commit('changeArmada', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createArmada({ commit, state, dispatch }) {
    commit('changeArmada', {
      loading: true,
    });

    let result = await ApiPostRequest(`armada`, state.data.form);
    commit('changeArmada', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateArmada({ commit, state, dispatch }, payload = null) {
    commit('changeArmada', {
      loading: true,
    });

    let result = await ApiPutRequest(`armada/${payload.id}`, state.data.form);

    commit('changeArmada', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteArmada({ commit, dispatch }, payload = null) {
    commit('changeArmada', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`armada/${payload.id}`);
    commit('changeArmada', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
